import React, { useEffect, useState } from "react";
import NoFooterModal from "../../Common/NoFooterModal";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DriverAssetsActions from "../../../store/actions/DriverAssets";
import * as UserActions from "../../../store/actions/User";
import ErrorMsgs from "../../../constants/Errors.json";
import SuccessMessages from "../../../constants/SucessMessages.json";
import "./PaymentModal.scss";
import { getPath } from "../../../utils";

const PaymentModal = (props) => {
  const {
    amount,
    driverId,
    assetId,
    initiatePayment,
    paymentStatus,
    setStatus,
    getTransactionStatus,
    handleClose,
    getDriverAssetsIssuedList,
    checkPaymentStatus,
  } = props;
  const [timer, setTimer] = React.useState({ minutes: 4, seconds: 60 });
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  // var timerInterval;
  const getTime = () => {
    return (
      timer.minutes +
      ":" +
      (timer.seconds / 10 < 1 ? "0" + timer.seconds : timer.seconds)
    );
  };
  const updateTimer = () => {
    const time = { ...timer };
    if (time.seconds > 0) {
      if (time.seconds === 30 || time.seconds === 60) {
        getPath(paymentStatus, "transaction_id", false) &&
          getTransactionStatus({
            transaction_id: paymentStatus.transaction_id,
          }).then((res) => {
            console.log(res);
            if (res && res.transaction_status.status === "COMPLETE") {
              // time.seconds=-999;
              // time.minutes=-999;
              setPaymentSuccess(true);
            }
          });
      }
      time.seconds = time.seconds - 1;
    } else {
      if (time.minutes > 0) {
        time.minutes = time.minutes - 1;
        time.seconds = 60;
      }
    }
    setTimer(time);
  };
  useEffect(() => {
    const payload = {
      amount: amount,
      assets_issuance_id: assetId,
      driver_id: driverId,
    };
    initiatePayment(payload).then((res) => {
      //if amount to be paid is 0, close the modal and redirect to homepage
      if (res && res.data.force_complete) {
        getDriverAssetsIssuedList({ driver_id: driverId });
        handleClose();
      }
    });
  }, []);
  useEffect(() => {
    if (timer.minutes === 0 && timer.seconds === 0) {
      checkPaymentStatus({ transaction_id: paymentStatus.transaction_id }).then(
        (res) => {
          if (res) {
            getTransactionStatus({
              transaction_id: paymentStatus.transaction_id,
            }).then((res) => {
              if (res && res.transaction_status.status === "COMPLETE") {
                setStatus({
                  type: "success",
                  message: SuccessMessages.PAYMENT_SUCCESSFUL,
                });
              } else {
                setStatus({
                  type: "error",
                  message: ErrorMsgs.PAYMENT_NOT_SUCCESSFUL,
                });
              }
              handleClose();
              return;
            });
          }
        }
      );
    }
    if (paymentSuccess) {
      setStatus({
        type: "success",
        message: SuccessMessages.PAYMENT_SUCCESSFUL,
      });
      getDriverAssetsIssuedList({ driver_id: driverId });
      handleClose();
    }
    // else if(timer.minutes<0 && timer.seconds<0){
    //   console.log("step 3");
    //   setStatus({type:"success",message:SuccessMessages.PAYMENT_SUCCESSFUL});
    //   getDriverAssetsIssuedList({driver_id : driverId});
    //   handleClose();
    //   return;
    // }
    setTimeout(updateTimer, 1000);
  }, [timer.seconds]);

  // useEffect(()=>{
  //   const timerInterval = setInterval(updateTimer, 1000);
  //   return () => clearInterval(timerInterval);
  // },[]);

  return (
    <div className="payment-modal">
      <NoFooterModal
        header
        handleClose={handleClose}
        heading="Scan the QR code to make payment"
        subHeading="**Please do not reload the page until payment is done**"
      >
        <div className="timer-holder">
          Time Remaining to make the payment- {getTime()}
        </div>
        <img
          className="flex qr-code"
          src={paymentStatus.qr_url}
          alt="qr-code"
        />
      </NoFooterModal>
    </div>
  );
};

function mapStateToProps(state) {
  const { DriverAssets } = state;
  return {
    paymentStatus: DriverAssets.paymentStatus,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    initiatePayment: bindActionCreators(
      DriverAssetsActions.initiatePayment,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    getDriverAssetsIssuedList: bindActionCreators(
      DriverAssetsActions.getDriverAssetsIssuedList,
      dispatch
    ),
    getTransactionStatus: bindActionCreators(
      DriverAssetsActions.getTransactionStatus,
      dispatch
    ),
    checkPaymentStatus: bindActionCreators(
      DriverAssetsActions.checkPaymentStatus,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentModal);
